import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/gas"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46233 2.84966C6.22468 2.07231 7 1.28172 7 0C9 0 12 2.8104 12 5.5C12 8 10 8.97534 10 8.97534C10 6.5 8 5.5 8 5.5C8 6.57592 7.4212 7.07304 6.88634 7.53241C6.42696 7.92696 6 8.29367 6 8.97534C4.71846 8.3169 4 7 4 5.5C4 4.34079 4.7251 3.60141 5.46233 2.84966ZM1 11.323V10H15V11.323C15 11.7319 14.751 12.0996 14.3714 12.2514L10 14V15H6V14L1.62861 12.2514C1.24895 12.0996 1 11.7319 1 11.323Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Gas16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Gas16 = createIcon(IconComponent);